const styles = {
  modal: {
    borderRadius: 4,
    '& .MuiDialog-paper': {
      overflow: 'hidden',
      width: {
        sm: 600, md: 700, lg: 900,
      },
      maxWidth: { lg: 900 },
      height: {
        sm: 450, md: 450, lg: 675,
      },
      '@media(max-width: 321px)': {
        width: '100%',
        height: 241,
      },
      '@media(min-width: 322px) and (max-width: 600px)': {
        height: 283,
      },
      backgroundColor: 'background.default',
    },
  },
  iframe: {
    height: { sm: 'fill-available', md: 'fill-available' },
    '@media(max-width: 320px)': {
      height: 241,
    },
    '@media(min-width: 320px) and (max-width: 600px)': {
      height: 283,
    },
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
}

export default styles
